// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/object-get-own-property-symbols.js
// module id = 912
// module chunks = 0